import { render, staticRenderFns } from "./PublicBg.vue?vue&type=template&id=6aaf3a1e&scoped=true&"
import script from "./PublicBg.vue?vue&type=script&lang=js&"
export * from "./PublicBg.vue?vue&type=script&lang=js&"
import style0 from "./PublicBg.vue?vue&type=style&index=0&id=6aaf3a1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf3a1e",
  null
  
)

export default component.exports